import { useEffect } from 'react';
import PageLayout from '../../components/feature/PageLayout';
import { siteMeta } from '../../mocks/site';
import HomeHero from './components/Hero';
import CategoryBand from './components/CategoryBand';
import FeaturePicks from './components/FeaturePicks';
import LatestArchive from './components/LatestArchive';
import TrustBand from './components/TrustBand';
import TopicBand from './components/TopicBand';
import FaqSection from './components/FaqSection';
import HomeCta from './components/CtaSection';
import { useDocMeta } from '../../hooks/useDocMeta';

export default function HomePage() {
  const setMeta = useDocMeta(
    `${siteMeta.name}｜八卦爆料 · 陈年旧瓜 · 考古重读 · 历史爆料`,
    siteMeta.description,
    siteMeta.keywords,
  );

  useEffect(() => {
    setMeta();
  }, [setMeta]);

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteMeta.name,
    description: siteMeta.description,
    url: siteMeta.domain,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteMeta.domain}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <PageLayout>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
      <HomeHero />
      <CategoryBand />
      <FeaturePicks />
      <LatestArchive />
      <TrustBand />
      <TopicBand />
      <FaqSection />
      <HomeCta />
    </PageLayout>
  );
}